import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Button, ButtonProps, CircularProgress } from "@mui/material";
import React from "react";

interface StyledButtonProps extends ButtonProps {
	backgroundColor?: string;
	hoverBackgroundColor?: string;
	hover?: boolean;
	disabledShadow?: boolean;
	height?: number;
}

export const StyledButton = styled(
	({
		backgroundColor,
		hoverBackgroundColor,
		hover,
		disabledShadow,
		height,
		...args
	}: StyledButtonProps) => <Button {...args} />,
)`
	text-transform: none;
	position: relative;

	${({ height }) => css`
		height: ${height}px;
	`}

	${({ backgroundColor, hover, hoverBackgroundColor, disabledShadow }) =>
		backgroundColor &&
		css`
			& {
				background-color: ${backgroundColor};
				${disabledShadow &&
				css`
					box-shadow: none;
				`}
			}

			&:hover {
				background-color: ${hover
					? hoverBackgroundColor || `inherit`
					: backgroundColor};

				${disabledShadow &&
				css`
					box-shadow: none;
				`}
			}
		`}
`;

export const ButtonSpinner = styled(CircularProgress)`
	width: 30px;
	height: 30px;
`;
